<script setup lang="ts">
  const { appBar } = defineProps<{
    appBar: boolean;
  }>();
  import { computed, ref, watch, type Ref } from 'vue';
  import { useRoute, useRouter } from 'vue-router';

  import { EnumRoutes } from '@/helpers/enums/routes.enum';

  import SearchTextField from './SearchTextField.vue';

  const take: Ref<number> = ref(12);

  const search: Ref<string | null> = ref('');

  let timeoutHandle: ReturnType<typeof setTimeout>;
  const router = useRouter();
  const handleSearchTextChange = () => {
    clearTimeout(timeoutHandle);

    if (!search.value) {
      searchHandler();
      return;
    }
    timeoutHandle = setTimeout(() => {
      searchHandler();
    }, 500);
  };
  const searchHandler = () => {
    router.push({
      name: EnumRoutes.lms.allCourses.name,
      query: { search: search.value ?? null },
    });
  };

  const showMenu = computed(() => appBar);
  const showDialog = ref(false);
  watch(showDialog, () => {
    if (!showDialog.value) {
      search.value = null;
    }
  });
  const route = useRoute();
  const setData = () => {
    search.value = route.query.search?.toString() ?? null;
  };

  watch(
    () => route.name,
    (newName) => {
      if (newName === EnumRoutes.lms.allCourses.name) {
        setData();
      } else {
        search.value = null;
      }
    },
    { immediate: true }
  );
</script>
<template>
  <v-menu
    :model-value="showMenu"
    :open-on-click="false"
    :close-on-content-click="false"
    persistent
  >
    <template #activator="{ props }">
      <SearchTextField
        v-bind="props"
        v-model:search="search"
        @update="handleSearchTextChange"
      />
    </template>
  </v-menu>
</template>

<style scoped></style>
